import React from "react";
import { Table } from "react-bootstrap";
import { z } from "zod";
import { CommonSchemas } from "@a2ui/web_core/v0_9";
import { createComponentImplementation } from "@a2ui/react/v0_9";

// Generic fallback: renders an arbitrary array of row objects as a
// Bootstrap table, using <Table> from react-bootstrap for consistency with
// the rest of the app's list screens (see src/Devices/*).

export const DataTableApi = {
  name: "DataTable",
  schema: z.object({
    title: CommonSchemas.DynamicString.optional(),
    // Optional array of column keys (strings) or {key, label} objects.
    // When omitted, columns are inferred from the keys of the first row.
    columns: CommonSchemas.DynamicValue.optional(),
    rows: CommonSchemas.DynamicValue,
  }),
};

const normalizeColumns = (columns, rows) => {
  if (Array.isArray(columns) && columns.length > 0) {
    return columns.map((c) =>
      typeof c === "string" ? { key: c, label: c } : { key: c.key, label: c.label || c.key }
    );
  }
  const first = rows[0] || {};
  return Object.keys(first).map((key) => ({ key, label: key }));
};

const formatCell = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export const DataTable = createComponentImplementation(DataTableApi, ({ props }) => {
  const rows = Array.isArray(props.rows) ? props.rows : [];
  const columns = normalizeColumns(props.columns, rows);

  return (
    <div className="analytics-data-table">
      {props.title && <div className="fw-semibold mb-2">{props.title}</div>}
      <Table striped bordered hover size="sm" responsive>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={row?.id ?? i}>
              {columns.map((c) => (
                <td key={c.key}>{formatCell(row?.[c.key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
});

export default DataTable;
